import { GetObjectCommand } from '@aws-sdk/client-s3';
import { getSignedUrl as presign } from '@aws-sdk/s3-request-presigner';
import s3 from './s3';
import { expiryTime } from 'consts/s3';

// note: this provides a one time use url. For user clickable urls, use useGetSignedUrl
export const getSignedUrl = (key: string, contentType: string): Promise<string> | undefined => {
  if (!key) return undefined;
  return presign(s3, new GetObjectCommand({
    Bucket: process.env.REACT_APP_BUCKET,
    Key: key,
    ResponseContentType: contentType,
  }), { expiresIn: expiryTime });
};
